// Helper function to get icon based on node type and output status
export const getNodeIcon = (type: 'distribution' | 'formula', isOutput: boolean): string => {
  if (isOutput) return '🎯';
  return type === 'distribution' ? '📊' : '🧮';
};

